var _excluded = ["id", "name", "value"];

var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useField } from 'formik';
var Wrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  --size: var(--radio-size, 20px);\n\n  display: inline-block;\n  width: var(--size);\n  height: var(--size);\n  border-radius: 50%;\n  border: 1px solid var(--radio-border-color, #000);\n  padding: 2px;\n\n  .active {\n    border-radius: inherit;\n    width: 100%;\n    height: 100%;\n    background-color: var(--radio-active-color, #000);\n  }\n\n  input {\n    display: none;\n  }\n"])));

function Radio(_ref) {
  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useField = useField(name, _extends({
    type: 'radio',
    value: value
  }, props)),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    onClick: function onClick() {
      return helpers.setValue(value);
    }
  }), meta.value === value && /*#__PURE__*/React.createElement("div", {
    className: "active"
  }), /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "radio"
  }, field)));
}

Radio.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any
} : {};
export default Radio;